<template>
  <div>
    <h3>
      Puno hvala na interesovanju da postanete volonter/ka i izdvojenom vremenu
      na popunjavanju Prijave. Bićemo slobodni da Vas kontaktiramo ukoliko nam
      neki od Vaših odgovora nisu jasni. Obavjestićemo Vas čim odobrimo Vaš
      prijem u članstvo i MI Boke. Nadamo se skoroj uspješnoj saradnji na
      unaprjeđenju položaja osoba s invaliditetom u Crnoj Gori. Budite slobodni
      da nas
      <a href="https://imiboke.me/contact-us/" target="_blank">kontaktirate</a>
      za sve dodatne informacije.
    </h3>
  </div>
</template>

<script></script>
